export default function Title(){
    return(
        <div className="text-4xl text-white grid place-items-center">
            <img className="object-top h-16 w-16" src="https://cdn-icons-png.flaticon.com/512/3578/3578348.png"/>Howmanyplat.es
        </div>
    )
}